// extracted by mini-css-extract-plugin
export default {"root":"WeatherImage_root__TJkdI","weatherImage":"WeatherImage_weatherImage__fDuBc"};